import React, { useState } from 'react';

function GradeLevelDropdown({ selected, setSelected }) {
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(null);
  const numbers = Array.from({ length: 9 }, (_, i) => (i === 8 ? 'HS' : i + 1));
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', position: 'relative' }}>
      <span style={{
        fontFamily: 'var(--font-alumni)',
        fontSize: '18px',
        fontWeight: '500',
        letterSpacing: '0.178px',
      }}>
        Grade Level
      </span>
      <div
        style={{
          width: '67px',
          height: '64px',
          borderRadius: '18px',
          border: '3px solid var(--primary-color)',
          background: 'var(--background-color)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          cursor: 'pointer',
          userSelect: 'none',
        }}
        onClick={() => setOpen((o) => !o)}
        tabIndex={0}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
      >
        <span style={{
          fontFamily: 'var(--font-alumni)',
          fontSize: '28px',
          color: 'var(--black)',
          fontWeight: 700,
          alignSelf: 'flex-start',
        }}>{selected}</span>
        {/* Triangle icon */}
        <svg
          width="26"
          height="24"
          viewBox="0 0 24 19"
          fill="none"
          style={{ position: 'absolute', bottom: 6, left: '50%', transform: 'translateX(-50%)', pointerEvents: 'none' }}
        >
          <path d="M11.7352 18.5288L0.408109 0.310999L23.0624 0.311001L11.7352 18.5288Z" fill="var(--primary-color)" />
        </svg>
        {open && (
          <div
            style={{
              position: 'absolute',
              top: '70px',
              left: 0,
              width: '67px',
              background: 'var(--background-color)',
              border: '2px solid var(--primary-color)',
              borderRadius: '14px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              zIndex: 10,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            {numbers.map((num) => (
              <div
                key={num}
                style={{
                  padding: '0px 0',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontFamily: 'var(--font-alumni)',
                  fontSize: '26px',
                  background:
                    hovered === num || selected === num
                      ? 'var(--primary-color)'
                      : 'transparent',
                  color:
                    hovered === num || selected === num
                      ? 'var(--white)'
                      : 'var(--black)',
                  cursor: 'pointer',
                  transition: 'background 0.15s, color 0.15s',
                }}
                onMouseEnter={() => setHovered(num)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => {
                  setSelected(num);
                  setOpen(false);
                }}
              >
                {num}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const HomeScreen = ({ onNext }) => {
  const [selectedGrade, setSelectedGrade] = useState(null);
  // ...existing code...
  return (
    <div className="content-area">
      {/* Title */}
      <div style={{ padding: '10px 20px', textAlign: 'center' }}>
        <h1 className="title-main">
          Do you <em>really</em> know how well your child reads?
        </h1>
      </div>

      {/* Main content area with video and info */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '25px',
        padding: '10px',
        flex: 1
      }}>
        {/* Left side with video placeholder */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap', justifyContent: 'center' }}>
          <div className="" style={{ position: 'relative', width: 560, height: 315, background: '#eee', borderRadius: 12, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/VYnwRafN5hY?rel=0"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              style={{ border: 0 }}
            ></iframe>
          </div>
          {/* <div style={{ width: 560, textAlign: 'center' }}>
            <a href="https://youtu.be/VYnwRafN5hY" target="_blank" rel="noreferrer" style={{ fontSize: 14, color: 'var(--primary-color)' }}>
              Open video on YouTube
            </a>
          </div> */}

          {/* Right side content */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '5px',
            maxWidth: '50%',
            padding: '0px 0'
          }}>
            {/* Description */}
            <div className="text-description" style={{ maxWidth: '60%' }}>
              Your child will read aloud each grade-level passage, powered by Microsoft's speech recognition.
            </div>

            {/* Buttons section */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'end',
                gap: '10px',
                width: '100%',
                justifyContent: 'center',
                padding: '30px 0px'
              }}
            >
              {/* Grade Level dropdown always visible for changing selection */}
              <GradeLevelDropdown selected={selectedGrade} setSelected={setSelectedGrade} />
              {/* START button */}
              <button
                className="btn-primary btn-large"
                onClick={() => selectedGrade && onNext(selectedGrade)}
                disabled={!selectedGrade}
                style={{ width: '160px', opacity: selectedGrade ? 1 : 0.6, cursor: selectedGrade ? 'pointer' : 'not-allowed', ...(selectedGrade ? {} : { pointerEvents: 'none' }) }}
              >
                START
              </button>
            </div>


            {/* Stats section */}
            <div className="stats-section">
              <div className="stats-line"></div>

              <div className="stats-text">
                <div style={{ marginBottom: '0px' }}>
                  <span className="stats-highlight">60% of American students are not</span><br />
                  reading on grade level.
                </div>

                <div style={{ marginBottom: '0px' }}>
                  Is your child one of them?
                </div>
              </div>
              <div className="stats-line"></div>

              <div className="stats-text">
                <div style={{ fontWeight: '600', marginBottom: '0px' }}>
                  Readers are Leaders
                </div>
                <div style={{ fontWeight: '500' }}>
                  Bill Gates reads 50 books per year.
                </div>
              </div>

              <div className="stats-line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;
